<template>
  <v-row justify="center" no-gutters>

    <v-col cols="12">
      <v-row justify="center" dense>
        <v-col cols="12">
            <v-card>
              <v-card-text>
                <location-form
                    v-model="location" dense
                    enable-floor enable-apartment
                    map-height="200px"
                    :address-sm-col="12"
                    :apartment-sm-col="6"
                    :floor-sm-col="6"
                    :map-sm-col="12"
                    @clear="clear"
                    :address-first="false"
                    :enable-locality-combobox="true"
                ></location-form>
              </v-card-text>
            </v-card>

        </v-col>

      </v-row>
    </v-col>

    <v-col v-if="deliveryCost && deliveryDistance" cols="12" class="mt-2">
      <v-alert v-if="isDeliverable" class="text-left align-center mb-2" dense type="info">
        Costo de envío: <b>${{deliveryCost }}</b>({{ deliveryDistance }}Km)
      </v-alert>
      <v-alert v-else class="text-left align-center" dense type="info">
        Distancia: {{ deliveryDistance }} Km
      </v-alert>
    </v-col>

    <v-col v-if="location.address" cols="12" class="mb-1">
      <bar-time-mode ></bar-time-mode>
    </v-col>


    <!--#[EN HORA]-->
    <v-col v-if="isAsSonAsPosible && location.address && !loadingDeliveryCost" cols="12">
        <!--#[EN ZONA] => LOADING -->
        <loading v-if="loadingInZone" text="maps.zone.determiningZone"></loading>

        <!--#[isDeliverable] => TRUE -->
        <schedule-as-soon-as-posible v-model="time" enable-delivery-time />

    </v-col>

    <v-col v-if="isScheduled && location.address && !loadingDeliveryCost" cols="12">
      <v-row justify="center" dense>

        <v-col v-if="loadingInZone" cols="12">
          <loading text="maps.zone.determiningZone"></loading>
        </v-col>

        <v-col  cols="12">
          <v-row class="pt-2 pb-2">
            <v-col cols="12" md="6">
              <date-input outlined dense hide-details prepend-icon="" prepend-inner-icon="date_range" label="fecha" v-model="deliveryDate">
                <template v-slot:prepend-inner>
                  <v-icon :color="colorAccordingToDate">date_range</v-icon>
                </template>
              </date-input>
            </v-col>
            <v-col cols="12" md="6">
              <schedule-time-combobox v-model="time" delivery-mode dense hide-details></schedule-time-combobox>
            </v-col>
          </v-row>

        </v-col>

      </v-row>
    </v-col>


  </v-row>
</template>

<script>
import {Loading} from "@dracul/common-frontend"
import LocationForm from "@/modules/maps/components/LocationForm/LocationForm";
import LocationIsInZone from "@/modules/maps/mixins/LocationIsInZone";
import OrderProvider from "@/modules/delivery/providers/OrderProvider";
import ScheduleTimeCombobox
  from "@/modules/delivery/components-core/shared/ScheduleTimeCombobox/ScheduleTimeCombobox.vue";
import ScheduleAsSoonAsPosible
  from "@/modules/delivery/components-core/shared/ScheduleAsSoonAsPosible/ScheduleAsSoonAsPosible.vue";
import {Dayjs, DateInput} from "@dracul/dayjs-frontend";
import BarTimeMode from "@/modules/delivery/components-core/business/BarTimeMode/BarTimeMode.vue";

const AS_SON_AS_POSIBLE = 'AS_SON_AS_POSIBLE'
const SCHEDULED = 'SCHEDULED'
export default {
  name: "BarOrderModeDelivery",
  components: {
    BarTimeMode,
    ScheduleAsSoonAsPosible,
    ScheduleTimeCombobox,
    LocationForm,
    Loading,
    DateInput
  },
  mixins: [ LocationIsInZone],
  data() {
    return {
      showLocation: false,
      loadingDeliveryCost: false,
    }
  },
  created() {
    //this.recoveryLastLocation()
  },
  mounted() {
    //this.determineZone(this.location)
    this.determineOrderDeliveryCost()
    if (this.location.address) {
      this.showLocation = true
    }
    this.determineTimeMode()
  },
  computed: {
    colorAccordingToDate(){
      if(Dayjs().isBefore(this.deliveryDate)){
        return "purple"
      }else{
        return "grey"
      }
    },
    deliveryCost(){
      return this.$store.getters.orderSystem.order.delivery.cost
    },
    deliveryDistance(){
      return this.$store.getters.orderSystem.order.delivery.distance
    },
    isCalendarActive(){
      return this.$store.getters.orderSystem.isCalendarDeliveryActive()
    },
    hasAdressNumber() {
      if (/[0-9]+/.test(this.location.address)) {
        return true
      } else {
        return false
      }
    },
    getDurationMin() {
      return this.duration ? this.duration / 60 : null
    },
    isDeliverable() {
      if (this.$store.getters.orderSystem.order.delivery.distance < this.$store.getters.getSettingValue('maxKmForDelivery')) {
        return true
      } else {
        return false
      }
    },
    location: {
      get() {
        return this.$store.getters.orderSystem.order.location
      },
      set(val) {
        this.showLocation = true
        this.setDeliveryTime(null)
        this.$store.commit('orderLocation', val)
        //this.determineZone(val)
        this.determineOrderDeliveryCost()
      }
    },
    getMessageOutOfTime() {
      return this.$store.getters.getSettingValue('MessageOutOfTime')
    },
    getMessageOutOfZone() {
      return this.$store.getters.getSettingValue('MessageOutOfZone')
    },
    getWhatsappNumber() {
      return this.$store.getters.getSettingValue('WhatsappNumber')
    },
    getWhatsappLink() {
      return 'https://api.whatsapp.com/send?phone=' + this.getWhatsappNumber
    },
    isAsSonAsPosible() {
      return this.$store.getters.orderSystem.order.isAsSoonAsPossible
    },
    isScheduled() {
      return this.$store.getters.orderSystem.order.isScheduled
    },
    timeMode(){
      return this.$store.getters.orderSystem.order.delivery.timeMode
    },
    time: {
      get() {
        return this.$store.getters.orderSystem.order.delivery.time
      },
      set(v) {
        this.$store.commit('orderTime', v)
      }
    },
    deliveryDate: {
      get() {
        return this.$store.getters.deliveryDate;
      },
      set(value) {
        this.$store.commit("orderDate", value);
      }
    }
  },

  methods: {
    determineOrderDeliveryCost() {
      this.loadingDeliveryCost = true
      let branchId = this.$store.getters.branchSelected.id
      let destination = this.$store.getters.orderSystem.order.location.address
      let destinationPlaceId = this.$store.getters.orderSystem.order.location.place_id

      if (branchId && destination) {
        OrderProvider.orderDeliveryCost(branchId, destination, destinationPlaceId)
            .then(r => {
              this.$store.commit("orderDeliveryCost", r.data.orderDeliveryCost.cost)
              this.$store.commit("orderDeliveryDistance", r.data.orderDeliveryCost.distanceKm)
              this.$store.commit("orderDeliveryLongDistance", r.data.orderDeliveryCost.longDistance)
            })
            .catch(e => {
              console.error("determineOrderDeliveryCost", e)
            })
            .finally(() => this.loadingDeliveryCost = false)
      }
    },
    determineTimeMode() {
      if (this.$store.getters.orderSystem.isCalendarDeliveryActive()) {
        this.asSonAsPosible()
      } else {
        this.scheduled()
      }
    },
    locationSelected(location) {
      this.location = Object.assign({}, location)
      this.showLocation = true
    },
    locationNew() {
      this.$store.commit('clearOrderLocation')
      this.showLocation = true
    },
    clear() {
      this.clearZone()
      this.setDeliveryTime(null)
      this.$store.commit('orderDeliveryCost', null)
      this.$store.commit('orderDeliveryDistance', null)
    },
    determineZone(location) {
      this.findLocationZone(location)
    },
    isBusinessHours() {
      return true
    },
    asSonAsPosible() {
      this.$store.commit('orderTimeMode', AS_SON_AS_POSIBLE)
    },
    scheduled() {
      this.$store.commit('orderTimeMode', SCHEDULED)
    },
    setDeliveryTime(val) {
      this.$store.commit('orderTime', val)
    }
  }
}
</script>

<style scoped>

</style>
